export default ` mutation CreateAirwallexSession($cart_id: String!,$return_url:String!, $customer_email: String) {
  createAirwallexSession(input: {
    cart_id: $cart_id
    return_url: $return_url
    customer_email: $customer_email
  }) {
    client_secret
    payment_intent_id
    session_id
    publishable_key
    amount
    currency
    customer_id
  }
}
`;
